import { render, staticRenderFns } from "./AmoCrmAuthBtn.vue?vue&type=template&id=3976e8ae&scoped=true"
import script from "./AmoCrmAuthBtn.vue?vue&type=script&lang=ts"
export * from "./AmoCrmAuthBtn.vue?vue&type=script&lang=ts"
import style0 from "./AmoCrmAuthBtn.vue?vue&type=style&index=0&id=3976e8ae&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3976e8ae",
  null
  
)

export default component.exports